// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np[data-v-2a590f23] {\n  font-size: 2em;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
